import ReactDOM from 'react-dom/client';
import { watchDeployedBuild } from '@shared/lib';
import App from './App';

// A tab left open across a release reloads onto it (`deployedBuild`); a dev server never differs.
if (process.env.NODE_ENV === 'production') watchDeployedBuild();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
